import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import "../layouts/layout-tabla.css";

/**
 * Layout base reutilizable para todos las tablas.
 *
 * Props:
 *  - titulo      (string)    Título que aparece en el header. Requerido.
 *  - logo        (string)    Ruta/import de la imagen del logo. Requerido.
 *  - onVolver    (function)  Opcional. Si no se pasa, hace navigate(-1) por defecto.
 *  - children    (ReactNode) Contenido del módulo.
 */

function TableLayout({ titulo, logo, onVolver, children, toastRef }) {
  const navigate = useNavigate();
  const volverAtras = onVolver ?? (() => navigate(-1));

  return (
    <div className="tab-container">
      <header className="tab-header pb-2">
        <div className="flex gap-3 align-items-center">
          <Button
            type="button"
            icon="pi pi-arrow-left"
            className="btn-volver-login"
            onClick={volverAtras}
          />
          <h2 className="tab-titulo mt-1 mb-0">{titulo}</h2>
        </div>
        <img src={logo} alt="Logo Transkyrios" className="tab-logo"/>
      </header>

      {/* CONTENIDO DEL MÓDULO */}
      {children}

    </div>
  );
}

export default TableLayout;